import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  $('body').on('bless', function(e) {
    var $target = $(e.target),
      $removeButtons = $target.is('[data-remove]')
        ? $target
        : $target.find('[data-remove]')
    debugLogScriptName($removeButtons, 'remove-button.js') // DEBUG
    $removeButtons.on('click', function(e) {
      const $saveBookingButtons = $('.save-booking-button')
      const $removeTarget = $($(this).attr('data-remove')),
        $removeTargetParent = $removeTarget.parent()
      $removeTarget.remove()
      $removeTargetParent.trigger('bless')

      if (!$('.table__cell--product').length) {
        $saveBookingButtons.prop('disabled', true)
      }
    })
  })
})
